<template>
  <div v-if="initialData">
    <FinancingIndex
      v-if="initialData.currentTenant.service_finance?.enabled"
      v-bind="initialData"
    />
    <div v-else class="container-fluid">
      <div class="row">
        <main class="col-md-12 ml-sm-auto col-lg-12 pt-3 pb-4 px-4">
          <div
            class="d-flex flex-row flex-wrap align-items-center pb-0 mb-3 justify-content-center-between page-header-content"
          >
            <h1 class="page-header-1">Financing</h1>
          </div>
          <div class="card p-4 text-center">
            <h5 class="mb-2">No Financing Integrations Enabled</h5>
            <p class="mb-0">
              Explore financing integration options in the
              <a :href="initialData.marketplacePath">Marketplace</a> section
            </p>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";

import FinancingIndex from "@/Financing/FinancingIndex.vue";

const initialData = ref<{
  currentTenant: Record<string, any>;
  departmentOptions: Record<string, unknown>[];
  loanProgramFilters: Record<string, unknown>[];
  loanProgramSource: string;
  marketplacePath: string;
} | null>(null);

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>
